import EventBuilder from './DragAndDrop/EventBuilder'

class PressAndHold {
  constructor () {
    this.duration = 500
    this.timeout = null
    this.isPressAndHold = false
    this.el = null
  }

  _startTimer () {
    this.timeout = setTimeout(() => {
      this.isPressAndHold = true
      this.el.dispatchEvent(EventBuilder.createPressHoldStartEvent())
    }, this.duration)
  }

  startDetection (e, el) {
    e.preventDefault()
    this.el = el
    this._startTimer()
  }

  stopDetection() {
    clearTimeout(this.timeout)

    if (this.isPressAndHold) {
      this.el.dispatchEvent(EventBuilder.createPressHoldEndEvent())
    } else {
      this.el.dispatchEvent(EventBuilder.createPressEndEvent())
    }

    this._reset()
  }

  _reset () {
    this.isPressAndHold = false
    this.timeout = null
  }
}

export default new PressAndHold()
